var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.increment('sxs','ppp')}}},[_vm._v("Button")]),_vm._v(" "+_vm._s(_vm.i)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }